export default function DetalhesEmpresa({ empresa, nota }: iProps) {
    return (
        <div style={{ fontSize: "0.9em" }}>
            <p>Razão Social: {empresa.nome}</p>
            <p>CNPJ: {empresa.cnpj} | Inscrição Municipal: {empresa.inscricao_municipal}</p>
            <p>Endereço: {empresa.logradouro} {empresa.numero} {empresa.bairro}, {empresa.complemento}, CEP {empresa.cep} {empresa.cidade}/{empresa.uf}</p>
            <p>Contato: Telefone {empresa.telefone} - Email {empresa.email}</p>
            {Object.values(nota).length > 0 && <div>
                {nota.simples_nacional_op === 1 && <p>NÃO OPTANTE SIMPLES NACIONAL</p>}
                {nota.simples_nacional_op === 3 && <p>OPTANTE SIMPLES NACIONAL - ISS {nota.ISS}</p>}
            </div>}
        </div>
    )
}
interface iProps {
    empresa: any
    nota: any
}